/**
 * @format
 */

import App from './App.web';
import registerRootComponent from 'expo/build/launch/registerRootComponent';

registerRootComponent(App);
